import Request from '../../api/Request';
import ProductAttributeRelationsParcel from '../endpoints/product/ProductAttributeRelationsParcel';

const STORE = {
    data: null,
    error: null
};

const listeners = [];

function addListener(listener) {
    if (!listeners.includes(listener)) {
        listeners.push(listener);
    }
}

function removeListener(listener) {
    if (listeners.includes(listener)) {
        listeners.splice(listeners.indexOf(listener), 1);
    }
}

function load() {
    Request.add(new ProductAttributeRelationsParcel())
        .then(data => {
            if (STORE.data === null) {
                STORE.data = {};
            }

            for (let relationName in data) {
                if (data.hasOwnProperty(relationName)) {
                    STORE.data[relationName] = data[relationName];
                }
            }

            listeners.forEach(f => f(true));
        })
        .catch(error => {
            STORE.error = error.getMessage();

            listeners.forEach(f => f(false));
        });
}

function getData() {
    return STORE.data;
}

function getError() {
    return STORE.error;
}

export default {
    load,
    getData,
    getError,
    addListener,
    removeListener,
}
